const validateAgainstMask = (mask, value) => {
  // BECAREUL USING THIS
  // THIS ONLY WORKS WITH REGEX OF SINGLE CHARACTERS
  // DO NOT USE THIS FOR MULTI NUMBER MASK PATTERNS
  //
  // VALID EXAMPLE:
  // ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  //
  // BAD EXAMPLE:
  // [[a-zA-Z]{3,10}, '.', '(com||co||org)']
  //
  // If mask is false we are disabling masking
  // So all values are valid
  if (mask === false || mask === undefined) return true;
  // There is a mask present but the value is not present
  if (value === undefined) return false;
  // Check length
  if (mask.length !== value.length) return false;
  // Check char value
  for (let i = 0; i < mask.length; i += 1) {
    // Test if the character is valid regex
    let isRegex = false;
    let pattern;
    try {
      pattern = new RegExp(mask[i]);
      isRegex = true;
    } catch (e) {
      isRegex = false;
    }
    // If it is then use it to test against the value
    // If not then see if the value matches
    if (isRegex) {
      if (!pattern.test(value[i])) return false;
    } else {
      if (mask[i] !== value[i]) return false;
    }
  }
  return true;
};

export default validateAgainstMask;
